<template>
  <div class="_content">
    <!-- 门店 -->
    <div class="item">
      <div class="item-row bottom-line">
        <div class="title">店招名称</div>
        <input
          class="val"
          type="text"
          v-model="form.shopName"
          placeholder=" 请填写店铺招牌名称"
          maxlength="40"
          :readonly="eventFlag"
        />
      </div>

      <div class="item-row bottom-line">
        <div class="title">门店负责人</div>
        <input
          class="val"
          type="text"
          v-model="form.shopPrincipal"
          placeholder=" 请填写姓名"
          maxlength="40"
          :readonly="eventFlag"
        />
      </div>

      <div class="item-row bottom-line">
        <div class="title">门店电话</div>
        <input class="val" type="number" v-model="form.shopPhone" placeholder="请填写" :readonly="eventFlag" />
      </div>

      <div class="item-row bottom-line">
        <div class="title">所在区域</div>
        <input
          class="val"
          v-model="form.city"
          @click="!eventFlag ? (showCityFlag = true) : ''"
          placeholder="请选择"
          readonly
        />
        <img class="arrow-right" src="~@/imgs/arrow-right-grey.png" alt="" />
      </div>

      <div class="item-row bottom-line">
        <div class="title">门店地址</div>
        <input
          class="val"
          type="text"
          v-model="form.shopAddress"
          placeholder=" 请填写详细地址"
          maxlength="60"
          :readonly="eventFlag"
        />
      </div>
    </div>

    <!-- 门店照片 -->
    <div v-if="!eventFlag" class="item1 marginTop">
      <div class="padding75 fontSize75 bottom-line">证照及门店照片</div>
      <div class="item-row">
        <div class="upload-box">
          <div
            class="upload"
            @click="imgType = 'doorPhoto'"
            v-upload="{ onUpload: upload, vin: false, index: 0, refresh: true, readonly: eventFlag }"
          >
            <img v-show="!form.doorPhoto" src="~@/imgs/upload-bg.png" class="uploadImg" alt="" />
            <img v-show="form.doorPhoto" :src="form.doorPhoto" class="uploadImg" alt="" />
            <p class="marginTop">门头照片 <span style="color:red"> *</span></p>
            <img
              v-show="form.doorPhoto && !eventFlag"
              @click.stop="uploadClear('doorPhoto')"
              class="uploadClose"
              src="~@/imgs/close.png"
              alt=""
            />
          </div>

          <div
            class="upload"
            @click="imgType = 'businessLicense'"
            v-upload="{ onUpload: upload, vin: false, index: 0, refresh: true, readonly: eventFlag }"
          >
            <img v-show="!form.businessLicense" src="~@/imgs/upload-bg.png" class="uploadImg" alt="" />
            <img v-show="form.businessLicense" :src="form.businessLicense" class="uploadImg" alt="" />
            <img
              v-show="form.businessLicense && !eventFlag"
              @click.stop="uploadClear('businessLicense')"
              class="uploadClose"
              src="~@/imgs/close.png"
              alt=""
            />
            <p class="marginTop">营业执照<span style="color:red"> *</span></p>
          </div>
        </div>
      </div>

      <div class="item-row">
        <div class="upload-box">
          <div
            class="upload"
            @click="imgType = 'workingArea'"
            v-upload="{ onUpload: upload, vin: false, index: 0, refresh: true, readonly: eventFlag }"
          >
            <img v-show="!form.workingArea" src="~@/imgs/upload-bg.png" class="uploadImg" alt="" />
            <img v-show="form.workingArea" :src="form.workingArea" class="uploadImg" alt="" />
            <img
              v-show="form.workingArea && !eventFlag"
              @click.stop="uploadClear('workingArea')"
              class="uploadClose"
              src="~@/imgs/close.png"
              alt=""
            />
            <p class="marginTop">工位图</p>
          </div>

          <div
            class="upload"
            @click="imgType = 'restArea'"
            v-upload="{ onUpload: upload, vin: false, index: 0, refresh: true, readonly: eventFlag }"
          >
            <img v-show="!form.restArea" src="~@/imgs/upload-bg.png" class="uploadImg" alt="" />
            <img v-show="form.restArea" :src="form.restArea" class="uploadImg" alt="" />
            <img
              v-show="form.restArea && !eventFlag"
              @click.stop="uploadClear('restArea')"
              class="uploadClose"
              src="~@/imgs/close.png"
              alt=""
            />
            <p class="marginTop">休息区</p>
          </div>
        </div>
      </div>

      <div class="item-row">
        <div class="upload-box">
          <div
            class="upload"
            @click="imgType = 'other'"
            v-upload="{ onUpload: upload, vin: false, index: 0, refresh: true, readonly: eventFlag }"
          >
            <img v-show="!form.other" src="~@/imgs/upload-bg.png" class="uploadImg" alt="" />
            <img v-show="form.other" :src="form.other" class="uploadImg" alt="" />
            <img
              v-show="form.other && !eventFlag"
              @click.stop="uploadClear('other')"
              class="uploadClose"
              src="~@/imgs/close.png"
              alt=""
            />
            <p class="marginTop">其他</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 回显 -->
    <div v-if="eventFlag" class="item1 marginTop">
      <div class="padding75 fontSize75 bottom-line">证照及门店照片</div>
      <div class="item-row">
        <div class="upload-box">
          <div class="upload">
            <img v-show="!form.doorPhoto" src="~@/imgs/upload-bg.png" class="uploadImg" alt="" />
            <img v-show="form.doorPhoto" :src="form.doorPhoto" class="uploadImg" alt="" />
            <p class="marginTop">门头照片 <span style="color:red"> *</span></p>
          </div>

          <div class="upload">
            <img v-show="!form.businessLicense" src="~@/imgs/upload-bg.png" class="uploadImg" alt="" />
            <img v-show="form.businessLicense" :src="form.businessLicense" class="uploadImg" alt="" />
            <p class="marginTop">营业执照</p>
          </div>
        </div>
      </div>

      <div class="item-row">
        <div class="upload-box">
          <div class="upload">
            <img v-show="!form.workingArea" src="~@/imgs/upload-bg.png" class="uploadImg" alt="" />
            <img v-show="form.workingArea" :src="form.workingArea" class="uploadImg" alt="" />
            <p class="marginTop">工位图</p>
          </div>

          <div class="upload">
            <img v-show="!form.restArea" src="~@/imgs/upload-bg.png" class="uploadImg" alt="" />
            <img v-show="form.restArea" :src="form.restArea" class="uploadImg" alt="" />
            <p class="marginTop">休息区</p>
          </div>
        </div>
      </div>

      <div class="item-row">
        <div class="upload-box">
          <div class="upload">
            <img v-show="!form.other" src="~@/imgs/upload-bg.png" class="uploadImg" alt="" />
            <img v-show="form.other" :src="form.other" class="uploadImg" alt="" />
            <p class="marginTop">其他</p>
          </div>
        </div>
      </div>
    </div>

    <!-- bank -->
    <div class="item marginTop">
      <div class="item-row bottom-line">
        <div class="title">开户银行</div>
        <input
          class="val"
          type="text"
          v-model="form.bankName"
          @click="!eventFlag ? toBankList() : ''"
          readonly
          placeholder="请选择"
        />
        <img class="arrow-right" src="~@/imgs/arrow-right-grey.png" alt="" />
      </div>

      <div class="item-row bottom-line">
        <div class="title">开户支行</div>
        <input
          class="val"
          type="text"
          v-model="form.bankBranchName"
          placeholder="请填写"
          maxlength="40"
          :readonly="eventFlag"
        />
      </div>

      <div class="item-row bottom-line">
        <div class="title">账户名称</div>
        <input
          class="val"
          type="text"
          v-model="form.bankAccountName"
          placeholder="请填写"
          maxlength="40"
          :readonly="eventFlag"
        />
      </div>

      <div class="item-row bottom-line">
        <div class="title">银行账号</div>
        <input class="val" v-model="form.bankAccount" maxlength="25" placeholder="请填写" :readonly="eventFlag" />
      </div>
    </div>

    <!-- 协议 -->
    <!-- <div class="agreement">
      <img v-show="agreementFlag" src="~@/imgs/success.png" alt="" @click="agreementFlag = !agreementFlag" />
      <img v-show="!agreementFlag" src="~@/imgs/unselected.png" alt="" @click="agreementFlag = !agreementFlag" />
      <div @click="toAssignMent">勾选即代表同意<span>《小鲲车服入驻协议》</span></div>
    </div> -->

    <!-- btn -->
    <div class="marginTop" v-if="merchantSignFlag === 0 || merchantSignFlag === '0' || signFlag === 0||  signFlag === '0'" @click="submit">
      <tt-button text="提交" />
    </div>


    <div class="marginTop" v-else @click="toAssignMent">
      <tt-button text="去签署协议" />
    </div>
    
    <!-- 客服 -->
    <div class="kefu" v-call>如有疑问请咨询小鲲车服<span>400-176-8848</span></div>
    <van-popup v-model="showCityFlag" round position="bottom">
      <city-picker
        :title="'选择所在区域'"
        :confirm="cityConfirm"
        :cancel="
          () => {
            showCityFlag = false
          }
        "
        ref="cPicker"
      ></city-picker>
    </van-popup>
  </div>
</template>

<script>
import ttButton from '@/components/ttButton.vue'
import cityPicker from '@/components/cityPicker.vue'
import config from '@/configs/config'
import successImg from '@/imgs/image/success.png'

export default {
  components: { ttButton, cityPicker },
  data() {
    return {
      lock: false,
      agreementFlag: false,
      showCityFlag: false,
      eventFlag: true,
      imgType: '',
      shopId: '',
      phone: '',
      shopNo: '', // 门店id加密字符串
      merchantCode: '',
      merchantSignFlag: null,
      signFlag: null,
      form: {
        shopName: '',
        shopPrincipal: '', // 门店负责人
        shopPhone: '',
        city: '',
        provinceId: '',
        provinceName: '',
        cityId: '',
        cityName: '',
        districtId: '',
        districtName: '',
        shopAddress: '',
        businessLicense: '', // 营业执照
        doorPhoto: '', // 门头照
        restArea: '', // 休息区
        workingArea: '', // 工位
        other: '', // 其他
        bankName: '',
        bankBranchName: '',
        bankAccountName: '', // 银行账户名
        bankAccount: '' // 银行卡号
      }
    }
  },
  created() {
    this.init()
  },
  computed: {
    bankInfo() {
      let info = JSON.parse(tuhu.store.state.bankInfo)
      return info
    }
  },
  watch: {
    bankInfo(val) {
      if (val) {
        this.form.bankName = val.text
      }
    }
  },
  methods: {
    init() {
      this.shopId = tuhu.getParam('shopId')
      this.phone = tuhu.getParam('phone')
      this.shopNo = tuhu.getParam('shopNo')
      this.merchantSignFlag = tuhu.getParam('merchantSignFlag')
      this.signFlag = tuhu.getParam('signFlag')
      this.merchantCode = tuhu.getParam('merchantCode')
      if (this.shopId && this.phone) {
        this.eventFlag = true
        this.getShopInfo()
      } else {
        this.eventFlag = false
      }
    },
    async getShopInfo() {
      const params = {
        shopId: this.shopId,
        sign: true
      }
      try {
        let res = await tuhu.fetch(`${config.apis.ADD_SHOP_DETAIL}`, {
          method: 'post',
          body: JSON.stringify(params)
        })
        if (res && res.code === '200') {
          if (res && res.data) {
            let data = res.data
            // 门店信息
            this.form.shopName = data.shopDetailInfo.shopName
            this.form.shopPrincipal = data.shopDetailInfo.shopPrincipal
            this.form.shopPhone = data.shopDetailInfo.shopPrincipalPhone

            this.form.city = `${data.shopDetailInfo.provinceName}-${data.shopDetailInfo.cityName}-${data.shopDetailInfo.districtName}`
            this.form.provinceId = data.shopDetailInfo.provinceId
            this.form.provinceName = data.shopDetailInfo.provinceName
            this.form.cityId = data.shopDetailInfo.cityId
            this.form.cityName = data.shopDetailInfo.cityName
            this.form.districtId = data.shopDetailInfo.districtId
            this.form.districtName = data.shopDetailInfo.districtName
            this.form.shopAddress = data.shopDetailInfo.shopName

            // 图片信息
            if (data.urlInfoList) {
              data.urlInfoList.map(li => {
                if (li.urlType === 'door_photo') {
                  this.form.doorPhoto = li.imgUrl
                } else if (li.urlType === 'business_license') {
                  this.form.businessLicense = li.imgUrl
                } else if (li.urlType === 'rest_area') {
                  this.form.restArea = li.imgUrl
                } else if (li.urlType === 'working_area') {
                  this.form.workingArea = li.imgUrl
                } else if (li.urlType === 'other') {
                  this.form.other = li.imgUrl
                }
              })
            }

            // 银行信息
            this.form.bankName = data.bankCardInfo.bankName
            this.form.bankBranchName = data.bankCardInfo.bankBranchName
            this.form.bankAccount = data.bankCardInfo.bankAccount
            this.form.bankAccountName = data.bankCardInfo.bankAccountName
          }
        } else {
          tuhu.toast(res.message || '网络错误')
          console.log(`${config.apis.GET_CODE}`, res)
        }
      } catch (e) {
        console.log(`${config.apis.GET_CODE}`, e)
      }
    },
    async toAssignMent() {
      if (this.lock) return false
      this.lock = true
      setTimeout(() => {
        this.lock = false
      }, 2000)
      const res = this.verify()
      if (res) {
        if(!this.shopId) tuhu.sessionStorage.setItem('shouldStorageShopForm', '1')
        tuhu.sessionStorage.setItem('shopForm', JSON.stringify(this.form))
        tuhu.navigateTo({
          url: '/pages/assignMent/index',
          query: {
            merchantCode: this.merchantCode,
            shopId: this.shopId
          }
        })
      }
    },
    async submit() {
      if (this.lock) return false
      this.lock = true
      setTimeout(() => {
        this.lock = false
      }, 2000)
      const res = this.verify()

      if (res) {
        let url = config.apis.SHOP_ADDSHOP
        // !this.eventFlag ? url = config.apis.SHOP_ADDSHOP : url = config.apis.SHOP_EDITSHOP
        let form = Object.assign(this.form, { shopId: this.shopId, merchantCode: this.merchantCode || 'XKKJ' })
        try {
          const data = await tuhu.fetch(`${url}`, {
            method: 'post',
            body: JSON.stringify(form)
          })
          if (data && data.code === '200') {
            let msg = '提交成功，请耐心等待审核！'
            tuhu.modal({
              title: '',
              text: `<img src="${successImg}" style="width:3.3rem; margin:0 auto">
                                    <div style="font-size:16px;font-weight:600;padding:.2rem 0">提交成功</div>
                                <div style="text-align:left">${msg}</div>`,
              buttons: [
                {
                  text: '知道了',
                  bold: true,
                  onClick: () => {
                    setTimeout(() => {
                      tuhu.redirectTo({ url: '/pages/_login/index' })
                    }, 200)
                  }
                }
              ]
            })
          } else {
            tuhu.toast(data.message || '网络异常')
            console.log(`${config.apis.SHOP_ADDSHOP}`, data.message)
          }
        } catch (e) {
          console.log(`${config.apis.SHOP_ADDSHOP}`, e)
        }
      }
    },
    cityConfirm(val, i) {
      let res = this.$refs.cPicker.cityData(i)

      this.form.city = val.join().replace(/,/g, '-')
      this.form.provinceName = val[0]
      this.form.cityName = val[1]
      this.form.districtName = val[2]
      this.form.provinceId = res.provinceId
      this.form.cityId = res.cityId
      this.form.districtId = res.districtId
      this.showCityFlag = false
    },
    upload(val) {
      if (val && val.code === '200' && val.data) {
        this.form[this.imgType] = val.data
      } else {
        tuhu.toast(val.message || '网络错误')
      }
    },
    uploadClear(type) {
      this.form[type] = ''
    },
    toBankList() {
      tuhu.navigateTo({
        url: '/pages/bankList/index'
      })
    },
    verify() {
      if (!this.form.shopName) return tuhu.toast('请填写店铺招牌名称')
      if (!this.form.shopPrincipal) return tuhu.toast('请填写门店负责人名称')
      if (!this.form.shopPhone) return tuhu.toast('请填写手机号')
      if (!this.form.city) return tuhu.toast('请选择门店所在区域')
      if (!this.form.shopAddress) return tuhu.toast('请填写门店地址')

      if (!this.form.doorPhoto) return tuhu.toast('请上传门头照')
      if (!this.form.businessLicense) return tuhu.toast('请上传营业执照')

      if (!this.form.bankName) return tuhu.toast('请选择开户银行')
      if (!this.form.bankBranchName) return tuhu.toast('请填写开户支行')
      if (!this.form.bankAccountName) return tuhu.toast('请填写账户名称')
      if (!this.form.bankAccount) return tuhu.toast('请填写银行卡号')

    //   if (!this.agreementFlag) return tuhu.toast('请勾选入驻协议')

      return true
    },
    toAgreement() {
      tuhu.navigateTo({
        url: '/pages/agreement/index',
        query: {
          shopNo: this.shopNo || ''
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
._content {
  background: #f5f5f5;
  padding: 0.75rem;

  .item {
    background: #fff;
    border-radius: 0.4rem;
    padding: 0 0.75rem;
    .item-row {
      height: 3rem;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 0.75rem 0 0;
      > input {
        padding: 0.5rem 0;
      }
      .val {
        flex: 1;
        text-align: right;
        margin-left: 0.5rem;
      }
      .arrow-right {
        position: absolute;
        right: -0.25rem;
        top: 1.1rem;
        width: 0.75rem;
        height: 0.75rem;
      }
    }
  }

  .item1 {
    border-radius: 0.4rem;
    background: #fff;
    .item-row {
      display: flex;
      flex-direction: column;
      padding: 0.75rem;
      > input {
        padding: 0.5rem 0;
      }
      .upload-box {
        display: flex;
        justify-content: space-between;
        padding: 0 1.5rem;
        .upload {
          display: flex;
          flex-direction: column;
          align-items: center;
          position: relative;
          .uploadImg {
            height: 4.4rem;
            width: 4.4rem;
          }
          .uploadClose {
            position: absolute;
            top: 0.1rem;
            right: 0.1rem;
            height: 1.1rem;
            width: 1.1rem;
          }
        }
        .upload1 {
          display: flex;
          flex-direction: column;
          align-items: center;
          position: relative;
          .uploadImg {
            height: 4.4rem;
            width: 4.4rem;
          }
          .uploadClose {
            position: absolute;
            top: 0.1rem;
            right: 0.1rem;
            height: 1.1rem;
            width: 1.1rem;
          }
        }
      }
    }
  }

  .agreement {
    display: flex;
    justify-content: center;
    padding: 1rem 0;
    > img {
      width: 0.8rem;
      height: 0.8rem;
      margin-right: 0.5rem;
    }
    span {
      color: @xkThemeCoder;
    }
  }

  .kefu {
    text-align: center;
    width: 100%;
    color: #bebebe;
    margin: 0.5rem 0;
    > span {
      color: @xkThemeCoder;
    }
  }
  // common
  @xkThemeCoder: #006eef;
  .fontSize75 {
    font-size: 0.75rem;
  }
  .fontWeight {
    font-weight: 600;
  }
  .fontColor6 {
    color: #666;
  }
  .fontColorBule {
    color: @xkThemeCoder;
  }
  .padding75 {
    padding: 0.75rem;
  }
  .marginTop {
    margin-top: 0.5rem;
  }
  .marginBottom {
    margin-bottom: 0.5rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/cooperation/shopInfo.vue